import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import globalCourseStore from '../../../../stores/global-course-store';
import { ApiErrorCodes } from '../../../../api/errors/api-error-codes';

export const deleteStudentOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  userId: number | undefined,
  setLoading: (lectureId: number | null) => any,
) => {
  try {
    if (!programId || !courseId || !userId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }

    setLoading(userId);
    const res = await appApi.removeStudentFromCourse(
      programId,
      courseId,
      userId,
    );

    if (
      res.data.errCode === ApiErrorCodes.DELETE_STUDENT_FROM_COURSE_HAS_USAGE
    ) {
      toast.warn('לא ניתן למחוק סטודנט שנכח בהרצאה בקורס');
      setLoading(null);
      return;
    }

    globalCourseStore.updateCourseDetails(
      courseId,
      res.data.body.metadata,
      res.data.body.details,
    );

    setLoading(null);
  } catch (e) {
    console.error(
      `deleteStudentOperation is failed with the programId: ${programId}, courseId: ${courseId}, userId: ${userId} and the error: ${e}`,
    );
    setLoading(null);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
